





















































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { WingBlank, DialogMain } from '@/components/index'
import { WebhookDetail, WebhookAdd, WebhookUpdata } from '@/api/Webhook'
import { WebhookPageForm, paramsType, WebhookAddForm } from '@/types/Webhook'
import { EmptyForm } from '@/utils/emptyForm'

@Component({
  components: {
    WingBlank,
    DialogMain
  },
})
export default class Tables extends Vue {
  emptyData = {
    src: require('@/assets/images/noData.png'),
    text: '请先创建或选择业务系统'
  }
  /**
   * dialogStatus 状态 用来判断 add or edit or cat
   *

   */
  dialogStatus = '';

  /**
   * 表格信息 tableObj
   * systemId 系统id
   */
  @Prop() tableObj!: any;
  @Prop() systemId!: number | null;

  dialogVisible = false;

  /**
   * 监听 dialogStatus 状态
   */
  @Watch('dialogStatus')
  handleDialogStatus(val: string) {
    if (val === '') {
      this.emptyForm()
      return
    }
    if (val === 'add') {
      this.dialogForm.params = JSON.parse(JSON.stringify(this.addParams))
      this.dialogForm.instanceObj = JSON.parse(JSON.stringify(this.instanceObjAll))
    } else {
      this.hanleShowDialog()
    }
  }
  /**
   * form
   *  search 搜索框、分页 和  选择状态按钮enabled数据
   */
  form: WebhookPageForm = {
    name: '',
    code: '',
    size: 10,
    current: 1,
    enabled: 0,
  };
  beforeUpdate() {
    const { systemId, form } = this
    if (systemId && systemId !== form.systemId) {
      this.form.current = 1
      this.form.systemId = systemId
      this.handleQueryPage()
    }
  }
  /**
   * 状态选择
   *
   */
  statusArr = ['全部', '启用中', '未启用'];

  /**
   * 表格 status切换
   */
  async handleSwitchStatus(item: any) {
    /**
     * 1启用
     * 2 禁用
     */
    const _form = { ...item }

    _form.enabled = item.enabled === 1 ? 2 : 1

    await WebhookUpdata(_form)
    this.handleQueryPage()
  }
  /**
   * 模态框
   * dialogForm 表单
   *  name: '', webhook名称
   * code:'',    编码
   * url:'',     接口地址
   * methods:''  请求方式
   *
   * handleConfirm 确定
   */
  /**
   * paramsAll 全部参数
   */
  addParams:paramsType[] = [
    {
      code: '',
      desc: '',
      type: 'preinstall',
      value: '',
    },
    {
      code: '',
      desc: '',
      type: 'custom',
      value: '',
    },
  ];
  paramsAll: paramsType[] = [
    {
      desc: '唯一标识',
      value: 'instance',
    },
  ];
  instanceObjAll: paramsType = {
    code: '',
    desc: '',
    type: 'instanceId',
  };
  /**
   * edit or cat 数据存储
   */
  serverForm: any = {};
  /**
   * dialog 显示信息
   */
  dialogForm:WebhookAddForm = {
    name: '',
    code: '',
    url: '',
    method: '',
    appkey: '',
    secret: '',
    instanceObj: {},
    params: [],
  };

  created() {
    this.handleQueryPage()
  }

  /**
   * 表格数据查询
   */
  handleQueryPage() {
    const _form = { ...this.form }
    _form.enabled = _form.enabled === 0 ? '' : _form.enabled
    this.$emit('on-handle-query-page', _form)
  }

  /**
   * 选择状态按钮触发
   */
  handleClickStatus(i: number, item: any) {
    this.form.enabled = i
    this.handleQueryPage()
  }

  /**
   * 表格编辑按钮
   *  获取单条数据
   *  数据回填
   * 打开dialog
   */
  async handleClickEdit(id: number) {
    const { data } = await WebhookDetail(id)
    data.params = JSON.parse(data.params)
    this.serverForm = data
    this.dialogStatus = 'edit'
  }

  /** 点击webhook名称
   * 查看
   * handleClickCat
   */
  async handleClickCat(id: number) {
    const { data } = await WebhookDetail(id)
    data.params = JSON.parse(data.params)
    this.serverForm = data
    this.dialogStatus = 'cat'
  }

  /**
   * 表格分页
   *  当前页大小
   */
  handleSizeChange(val: number) {
    this.form.size = val
    this.form.systemId = this.systemId
    this.handleQueryPage()
  }

  /**
   * 表格分页
   *  第几页
   */
  handleCurrentChange(val: number) {
    this.form.current = val
    this.form.systemId = this.systemId
    this.handleQueryPage()
  }

  /**
   * handleAddWebhook 添加webhook  打开
   */
  handleAddWebhook() {
    this.dialogStatus = 'add'
    this.dialogVisible = true
  }
  /**
   * 编辑 or 查看dialog
   */
  hanleShowDialog() {
    const { serverForm } = this
    const _serverForm = { ...serverForm }
    let _instanceObj = {}
    const outherArr = []

    for (let i = 0; i < serverForm.params.length; i++) {
      const item = _serverForm.params[i]
      if (item.type === 'instanceId') {
        _instanceObj = item
      } else {
        const obj = item
        if (!obj.value) {
          obj.value = ''
        }
        if (!obj.code) {
          obj.code = ''
        }
        if (!obj.desc) {
          obj.desc = ''
        }
        outherArr.push(obj)
      }
    }
    delete _serverForm.params
    _serverForm.instanceObj = _instanceObj
    _serverForm.params = outherArr

    this.dialogForm = _serverForm
    this.dialogVisible = true
  }
  /**
   * 添加  webhook参数
   */
  handleAddDialog() {
    const obj: paramsType = {
      code: '',
      desc: '',
      type: 'custom',
      value: '',
    }
    this.dialogForm.params.push(obj)
  }

  /**
   * 删除webhook参数
   */
  handleRemoveDialog(idx: number) {
    this.dialogForm.params.splice(idx, 1)
  }

  /**
   * 点击按钮触发
   *  自定义
   * 清空输入框内容
   */
  handleWebhookStatus(item: any) {
    item.value = ''
  }
  /**
   * Dialog确认按钮
   */
  async handleConfirm() {
    const _form: any = JSON.parse(JSON.stringify(this.dialogForm))
    const { dialogStatus, systemId } = this
    /**
     * dialogStatus
     *    cat 查看
     *    edit 编辑
     *    add  添加
     */
    if (dialogStatus !== 'cat') {
      _form.systemId = systemId
      _form.params.push(_form.instanceObj)
      _form.params = JSON.stringify(_form.params)
      delete _form.instanceObj

      if (dialogStatus === 'add') {
        delete _form.enabled
        await WebhookAdd(_form)
      } else {
        await WebhookUpdata(_form)
      }
      this.handleQueryPage()
    }
    this.emptyForm()
  }
  /**
   * 清空dialog内容
   */
  emptyForm() {
    this.dialogStatus = ''
    this.dialogVisible = false
    EmptyForm(this.dialogForm)
  }
  /**
   * Dialog 关闭按钮
   * handleClose
   */
  handleClose() {
    this.emptyForm()
  }
}
